import React from 'react';
import Tooltip from '@leafygreen-ui/tooltip';

export default (props) => <Tooltip className={fwTooltipId} {...props} />;
export const fwTooltipId = 'feedback-tooltip';
